module.exports = __webpack_public_path__ + "daggerSquareOblique.29ceb79.otf";